import React from 'react';
import { RecordStateProps } from './RecordState.type';
import './RecordState.scss';
import { useTranslation } from 'react-i18next';
import { useUserList } from '@utils/hooks/useUserList';
import { BOOL } from '@tencent/wemeet-websdk-next';

const RecordState: React.FC<RecordStateProps> = () => {
  const { t } = useTranslation();
  const userList = useUserList();
  if (userList.some((user) => user.local_record_on === BOOL.true)) {
    return <div className="record-state">{t('录制中')}</div>;
  }
  return null;
};

export default RecordState;
